const DEFAULT_TIMEOUT_MS = 30_000;

/** fetch wrapper with AbortSignal.timeout for Supabase and Edge calls. */
export function fetchWithTimeout(
  input: RequestInfo | URL,
  init?: RequestInit,
  timeoutMs = DEFAULT_TIMEOUT_MS,
): Promise<Response> {
  const signal =
    init?.signal ??
    (typeof AbortSignal.timeout === "function"
      ? AbortSignal.timeout(timeoutMs)
      : undefined);

  return fetch(input, { ...init, signal });
}
